/* Hook encargado de crear la nota de venta

Autor: Benjamín León
Fecha: 2024-10-01
*/
import { useState } from 'react'

import { SalenoteDto } from '../interfaces/SalenoteDto.ts'
import { normalizeDate } from '../utils/utils.ts'
import { customPost } from '../utils/customFetch.ts'
import { SalenoteFormat } from '../components/SalenoteEdit.tsx'

import { useAuth } from './useAuth.tsx'
import { makeUrlSalenoteCrea } from './connectionData.tsx'

const apiUrl = makeUrlSalenoteCrea()
const useSalenoteCrea = () => {
  const [errorSalenoteCrea, setErrorSalenoteCrea] = useState<Error | null>(null)
  const [loading, setLoading] = useState<boolean>(false)
  const { userData } = useAuth()
  const salenoteCrea = async (salenote: SalenoteFormat, accion: number) => {
    setLoading(true)

    try {
      const id = await updateDatabase(salenote, accion)
      setErrorSalenoteCrea(null)

      return id
    } catch (err) {
      // Assert the error as an instance of Error
      if (err instanceof Error) {
        setErrorSalenoteCrea(err)
      } else {
        setErrorSalenoteCrea(new Error('An unknown error occurred'))
      }

      return null
    } finally {
      setLoading(false)
    }
  }
  const updateDatabase = async (salenote: SalenoteFormat, accion: number): Promise<string> => {
    // Tenemos que cambiarle las fechas a
    // los pagos, costos
    ;(salenote.additionals ?? []).forEach((element) => {
      element.date = normalizeDate(element.date)
    })
    ;(salenote.payments ?? []).forEach((element) => {
      element.date = normalizeDate(element.date)
    })

    // TODO: POR AHORA, Cuando se crean,el usuario selecciona
    // un vehiculo, por lo que van las id del vehiculo
    ;(salenote.tradeIns ?? []).forEach((element) => {
      element._id = element.vehicle
    })

    const id = accion === 0 ? '' : salenote._id
    // Lo convertimos lo que espera la api

    const dto: SalenoteDto = {
      _id: id,
      price: salenote.price,
      notes: salenote.notes,
      number: salenote.number ?? 0,
      total: 0,
      reservation: salenote.reservation,
      vehicle: salenote.vehicle,
      organization: userData?.organization?._id ?? '',
      client: salenote.client,
      profile: accion === 0 ? userData?.profile?._id ?? '' : salenote.profile,
      additionals: salenote.additionals,
      payments: salenote.payments,
      credit: salenote.credit,
      balance: 0,
      date: normalizeDate(salenote.date),
      tradeIns: salenote.tradeIns,
      insuranceCo: salenote.insuranceCo,
      discount: salenote.discount,
      compraPara: salenote.compraPara,
    }

    const res = await customPost<{ _id: string }>(apiUrl, dto)

    return res._id
  }

  // Exponemos estas variables al exterior
  return { errorSalenoteCrea, loading, salenoteCrea }
}
export default useSalenoteCrea
